var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaillogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 41.667L41.667 20h-3.334L5 41.667v16.666h70V41.667z",
    fill: "#FCBD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 60V6.667A1.667 1.667 0 0116.667 5h35L65 18.333V60a1.666 1.666 0 01-1.667 1.667H16.667A1.666 1.666 0 0115 60z",
    fill: "#FFF8E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18.333H53.333a1.667 1.667 0 01-1.666-1.666V5L65 18.333z",
    fill: "#FEEBB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26.667H31.667a1.666 1.666 0 110-3.334H55a1.666 1.666 0 110 3.334zm0 6.666H25A1.667 1.667 0 0125 30h30a1.666 1.666 0 110 3.333zM55 40H25a1.666 1.666 0 110-3.333h30A1.667 1.667 0 0155 40zm20 33.333V41.667L46.667 53.333H33.333L5 41.667v31.666A1.667 1.667 0 006.667 75h66.666A1.667 1.667 0 0075 73.333z",
    fill: "#FDD354"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.45 74.583a1.738 1.738 0 01-1.117.417H6.667a1.738 1.738 0 01-1.117-.417l33.44-25.48a1.667 1.667 0 012.02 0l33.44 25.48z",
    fill: "#FEEBB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaillogo);
export default __webpack_public_path__ + "static/media/maillogo.2690e6e92f50ce8d0fd78418183009b5.svg";
export { ForwardRef as ReactComponent };